export const CURRENCIES = [
  {
    currency_code: "PEN",
    currency_name: "Peruvian Nuevo Sol",
    currency_symbol: "S/.",
  },
  {
    currency_code: "BYN",
    currency_name: "Belarusian Ruble",
    currency_symbol: "Br",
  },
  {
    currency_code: "DOP",
    currency_name: "Dominican Peso",
    currency_symbol: "RD$",
  },
  {
    currency_code: "MGA",
    currency_name: "Malagasy Ariary",
    currency_symbol: "MGA",
  },
  {
    currency_code: "NZD",
    currency_name: "New Zealand Dollar",
    currency_symbol: "NZ$",
  },
  {
    currency_code: "MOP",
    currency_name: "Macanese Pataca",
    currency_symbol: "MOP$",
  },
  {
    currency_code: "MYR",
    currency_name: "Malaysian Ringgit",
    currency_symbol: "RM",
  },
  {
    currency_code: "NPR",
    currency_name: "Nepalese Rupee",
    currency_symbol: "NPRs",
  },
  {
    currency_code: "ALL",
    currency_name: "Albanian Lek",
    currency_symbol: "ALL",
  },
  {
    currency_code: "UGX",
    currency_name: "Ugandan Shilling",
    currency_symbol: "USh",
  },
  {
    currency_code: "CVE",
    currency_name: "Cape Verdean Escudo",
    currency_symbol: "CV$",
  },
  {
    currency_code: "MMK",
    currency_name: "Myanma Kyat",
    currency_symbol: "MMK",
  },
  {
    currency_code: "OMR",
    currency_name: "Omani Rial",
    currency_symbol: "OMR",
  },
  {
    currency_code: "ERN",
    currency_name: "Eritrean Nakfa",
    currency_symbol: "Nfk",
  },
  {
    currency_code: "BAM",
    currency_name: "Bosnia-Herzegovina Convertible Mark",
    currency_symbol: "KM",
  },
  {
    currency_code: "ARS",
    currency_name: "Argentine Peso",
    currency_symbol: "AR$",
  },
  {
    currency_code: "BOB",
    currency_name: "Bolivian Boliviano",
    currency_symbol: "Bs",
  },
  {
    currency_code: "HRK",
    currency_name: "Croatian Kuna",
    currency_symbol: "kn",
  },
  {
    currency_code: "SGD",
    currency_name: "Singapore Dollar",
    currency_symbol: "S$",
  },
  {
    currency_code: "SDG",
    currency_name: "Sudanese Pound",
    currency_symbol: "SDG",
  },
  {
    currency_code: "PKR",
    currency_name: "Pakistani Rupee",
    currency_symbol: "PKRs",
  },
  {
    currency_code: "RON",
    currency_name: "Romanian Leu",
    currency_symbol: "RON",
  },
  {
    currency_code: "CRC",
    currency_name: "Costa Rican Colón",
    currency_symbol: "₡",
  },
  {
    currency_code: "LTL",
    currency_name: "Lithuanian Litas",
    currency_symbol: "Lt",
  },
  {
    currency_code: "SYP",
    currency_name: "Syrian Pound",
    currency_symbol: "SY£",
  },
  {
    currency_code: "THB",
    currency_name: "Thai Baht",
    currency_symbol: "฿",
  },
  {
    currency_code: "IDR",
    currency_name: "Indonesian Rupiah",
    currency_symbol: "Rp",
  },
  {
    currency_code: "TTD",
    currency_name: "Trinidad and Tobago Dollar",
    currency_symbol: "TT$",
  },
  {
    currency_code: "UYU",
    currency_name: "Uruguayan Peso",
    currency_symbol: "$U",
  },
  {
    currency_code: "ZWL",
    currency_name: "Zimbabwean Dollar",
    currency_symbol: "ZWL$",
  },
  {
    currency_code: "SEK",
    currency_name: "Swedish Krona",
    currency_symbol: "Skr",
  },
  {
    currency_code: "MAD",
    currency_name: "Moroccan Dirham",
    currency_symbol: "MAD",
  },
  {
    currency_code: "MDL",
    currency_name: "Moldovan Leu",
    currency_symbol: "MDL",
  },
  {
    currency_code: "LBP",
    currency_name: "Lebanese Pound",
    currency_symbol: "LB£",
  },
  {
    currency_code: "BND",
    currency_name: "Brunei Dollar",
    currency_symbol: "BN$",
  },
  {
    currency_code: "BZD",
    currency_name: "Belize Dollar",
    currency_symbol: "BZ$",
  },
  {
    currency_code: "LYD",
    currency_name: "Libyan Dinar",
    currency_symbol: "LD",
  },
  {
    currency_code: "XAF",
    currency_name: "CFA Franc BEAC",
    currency_symbol: "FCFA",
  },
  {
    currency_code: "PHP",
    currency_name: "Philippine Peso",
    currency_symbol: "₱",
  },
  {
    currency_code: "TRY",
    currency_name: "Turkish Lira",
    currency_symbol: "TL",
  },
  {
    currency_code: "CZK",
    currency_name: "Czech Republic Koruna",
    currency_symbol: "Kč",
  },
  {
    currency_code: "XOF",
    currency_name: "CFA Franc BCEAO",
    currency_symbol: "CFA",
  },
  {
    currency_code: "KRW",
    currency_name: "South Korean Won",
    currency_symbol: "₩",
  },
  {
    currency_code: "AED",
    currency_name: "United Arab Emirates Dirham",
    currency_symbol: "AED",
  },
  {
    currency_code: "HUF",
    currency_name: "Hungarian Forint",
    currency_symbol: "Ft",
  },
  {
    currency_code: "KZT",
    currency_name: "Kazakhstani Tenge",
    currency_symbol: "KZT",
  },
  {
    currency_code: "TND",
    currency_name: "Tunisian Dinar",
    currency_symbol: "DT",
  },
  {
    currency_code: "EUR",
    currency_name: "Euro",
    currency_symbol: "€",
  },
  {
    currency_code: "QAR",
    currency_name: "Qatari Rial",
    currency_symbol: "QR",
  },
  {
    currency_code: "GTQ",
    currency_name: "Guatemalan Quetzal",
    currency_symbol: "GTQ",
  },
  {
    currency_code: "IRR",
    currency_name: "Iranian Rial",
    currency_symbol: "IRR",
  },
  {
    currency_code: "SOS",
    currency_name: "Somali Shilling",
    currency_symbol: "Ssh",
  },
  {
    currency_code: "BIF",
    currency_name: "Burundian Franc",
    currency_symbol: "FBu",
  },
  {
    currency_code: "CNY",
    currency_name: "Chinese Yuan",
    currency_symbol: "CN¥",
  },
  {
    currency_code: "GNF",
    currency_name: "Guinean Franc",
    currency_symbol: "FG",
  },
  {
    currency_code: "LVL",
    currency_name: "Latvian Lats",
    currency_symbol: "Ls",
  },
  {
    currency_code: "AMD",
    currency_name: "Armenian Dram",
    currency_symbol: "AMD",
  },
  {
    currency_code: "BRL",
    currency_name: "Brazilian Real",
    currency_symbol: "R$",
  },
  {
    currency_code: "KHR",
    currency_name: "Cambodian Riel",
    currency_symbol: "KHR",
  },
  {
    currency_code: "UZS",
    currency_name: "Uzbekistan Som",
    currency_symbol: "UZS",
  },
  {
    currency_code: "TWD",
    currency_name: "New Taiwan Dollar",
    currency_symbol: "NT$",
  },
  {
    currency_code: "GHS",
    currency_name: "Ghanaian Cedi",
    currency_symbol: "GH₵",
  },
  {
    currency_code: "CDF",
    currency_name: "Congolese Franc",
    currency_symbol: "CDF",
  },
  {
    currency_code: "NAD",
    currency_name: "Namibian Dollar",
    currency_symbol: "N$",
  },
  {
    currency_code: "AUD",
    currency_name: "Australian Dollar",
    currency_symbol: "AU$",
  },
  {
    currency_code: "JOD",
    currency_name: "Jordanian Dinar",
    currency_symbol: "JD",
  },
  {
    currency_code: "SAR",
    currency_name: "Saudi Riyal",
    currency_symbol: "SR",
  },
  {
    currency_code: "KES",
    currency_name: "Kenyan Shilling",
    currency_symbol: "Ksh",
  },
  {
    currency_code: "KMF",
    currency_name: "Comorian Franc",
    currency_symbol: "CF",
  },
  {
    currency_code: "RWF",
    currency_name: "Rwandan Franc",
    currency_symbol: "RWF",
  },
  {
    currency_code: "CHF",
    currency_name: "Swiss Franc",
    currency_symbol: "CHF",
  },
  {
    currency_code: "PAB",
    currency_name: "Panamanian Balboa",
    currency_symbol: "B/.",
  },
  {
    currency_code: "AFN",
    currency_name: "Afghan Afghani",
    currency_symbol: "Af",
  },
  {
    currency_code: "EGP",
    currency_name: "Egyptian Pound",
    currency_symbol: "EGP",
  },
  {
    currency_code: "COP",
    currency_name: "Colombian Peso",
    currency_symbol: "CO$",
  },
  {
    currency_code: "BGN",
    currency_name: "Bulgarian Lev",
    currency_symbol: "BGN",
  },
  {
    currency_code: "BDT",
    currency_name: "Bangladeshi Taka",
    currency_symbol: "Tk",
  },
  {
    currency_code: "VEF",
    currency_name: "Venezuelan Bolívar",
    currency_symbol: "Bs.F.",
  },
  {
    currency_code: "INR",
    currency_name: "Indian Rupee",
    currency_symbol: "Rs",
  },
  {
    currency_code: "GBP",
    currency_name: "British Pound Sterling",
    currency_symbol: "£",
  },
  {
    currency_code: "BWP",
    currency_name: "Botswanan Pula",
    currency_symbol: "BWP",
  },
  {
    currency_code: "ETB",
    currency_name: "Ethiopian Birr",
    currency_symbol: "Br",
  },
  {
    currency_code: "JMD",
    currency_name: "Jamaican Dollar",
    currency_symbol: "J$",
  },
  {
    currency_code: "RSD",
    currency_name: "Serbian Dinar",
    currency_symbol: "din.",
  },
  {
    currency_code: "MZN",
    currency_name: "Mozambican Metical",
    currency_symbol: "MTn",
  },
  {
    currency_code: "USD",
    currency_name: "US Dollar",
    currency_symbol: "$",
  },
  {
    currency_code: "YER",
    currency_name: "Yemeni Rial",
    currency_symbol: "YR",
  },
  {
    currency_code: "TZS",
    currency_name: "Tanzanian Shilling",
    currency_symbol: "TSh",
  },
  {
    currency_code: "JPY",
    currency_name: "Japanese Yen",
    currency_symbol: "¥",
  },
  {
    currency_code: "ZAR",
    currency_name: "South African Rand",
    currency_symbol: "R",
  },
  {
    currency_code: "UAH",
    currency_name: "Ukrainian Hryvnia",
    currency_symbol: "₴",
  },
  {
    currency_code: "HKD",
    currency_name: "Hong Kong Dollar",
    currency_symbol: "HK$",
  },
  {
    currency_code: "DJF",
    currency_name: "Djiboutian Franc",
    currency_symbol: "Fdj",
  },
  {
    currency_code: "CAD",
    currency_name: "Canadian Dollar",
    currency_symbol: "CA$",
  },
  {
    currency_code: "PYG",
    currency_name: "Paraguayan Guarani",
    currency_symbol: "₲",
  },
  {
    currency_code: "VND",
    currency_name: "Vietnamese Dong",
    currency_symbol: "₫",
  },
  {
    currency_code: "NIO",
    currency_name: "Nicaraguan Córdoba",
    currency_symbol: "C$",
  },
  {
    currency_code: "AZN",
    currency_name: "Azerbaijani Manat",
    currency_symbol: "man.",
  },
  {
    currency_code: "PLN",
    currency_name: "Polish Zloty",
    currency_symbol: "zł",
  },
  {
    currency_code: "LKR",
    currency_name: "Sri Lankan Rupee",
    currency_symbol: "SLRs",
  },
  {
    currency_code: "MUR",
    currency_name: "Mauritian Rupee",
    currency_symbol: "MURs",
  },
  {
    currency_code: "NOK",
    currency_name: "Norwegian Krone",
    currency_symbol: "Nkr",
  },
  {
    currency_code: "MKD",
    currency_name: "Macedonian Denar",
    currency_symbol: "MKD",
  },
  {
    currency_code: "ZMK",
    currency_name: "Zambian Kwacha",
    currency_symbol: "ZK",
  },
  {
    currency_code: "ILS",
    currency_name: "Israeli New Sheqel",
    currency_symbol: "₪",
  },
  {
    currency_code: "KWD",
    currency_name: "Kuwaiti Dinar",
    currency_symbol: "KD",
  },
  {
    currency_code: "MXN",
    currency_name: "Mexican Peso",
    currency_symbol: "MX$",
  },
  {
    currency_code: "BHD",
    currency_name: "Bahraini Dinar",
    currency_symbol: "BD",
  },
  {
    currency_code: "HNL",
    currency_name: "Honduran Lempira",
    currency_symbol: "HNL",
  },
  {
    currency_code: "DZD",
    currency_name: "Algerian Dinar",
    currency_symbol: "DA",
  },
  {
    currency_code: "IQD",
    currency_name: "Iraqi Dinar",
    currency_symbol: "IQD",
  },
  {
    currency_code: "ISK",
    currency_name: "Icelandic Króna",
    currency_symbol: "Ikr",
  },
  {
    currency_code: "EEK",
    currency_name: "Estonian Kroon",
    currency_symbol: "Ekr",
  },
  {
    currency_code: "DKK",
    currency_name: "Danish Krone",
    currency_symbol: "Dkr",
  },
  {
    currency_code: "GEL",
    currency_name: "Georgian Lari",
    currency_symbol: "GEL",
  },
  {
    currency_code: "RUB",
    currency_name: "Russian Ruble",
    currency_symbol: "RUB",
  },
  {
    currency_code: "NGN",
    currency_name: "Nigerian Naira",
    currency_symbol: "₦",
  },
  {
    currency_code: "CLP",
    currency_name: "Chilean Peso",
    currency_symbol: "CL$",
  },
  {
    currency_code: "TOP",
    currency_name: "Tongan Paʻanga",
    currency_symbol: "T$",
  },
] as const;
